export const DEFAULT_COUNTRY_CODE = 'US'



// WEBPACK FOOTER //
// ./src/constants/registration/defaultCountryCode.js